import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Collapse, FormControlLabel, IconButton, Skeleton } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { blue, red } from '@mui/material/colors';
import { List } from 'immutable';
import React, { Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { fetchCustomerSpecialInstructionsForCustomerWithTypes } from '@sophocles/entities/CustomerSpecialInstruction';
import SpecialInstructionDisplay from '@sophocles/views/returns/components/SpecialInstructionDisplay';

class CustomerSpecialInstructionsCollapse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      loading: true,
      instructions: List(),
    };
  }

  componentDidMount() {
    const { customer, types, fetchSpecialInstructions, onToggle } = this.props;

    fetchSpecialInstructions(customer, types).then(res => {
      if (res.error) {
        return this.setState({ loading: false });
      }

      this.setState({ instructions: res, loading: false });

      if (!res.isEmpty()) {
        onToggle();
      }
    });
  }

  toggleView = () => this.setState({ open: !this.state.open });

  render() {
    const { checked, onToggle, t } = this.props;

    const { instructions, open, loading } = this.state;

    if (loading) {
      return (
        <Fragment>
          <Skeleton variant="rectangular" width="100%" height={50} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" width="100%" height={90} sx={{ mb: 2 }} />
        </Fragment>
      );
    }

    if (instructions.isEmpty()) {
      return null;
    }

    return (
      <div style={{ padding: '8px 0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h4 style={{ marginBottom: 0 }}>
            <IconButton onClick={this.toggleView}>
              {open ? <ExpandLessIcon sx={{ fill: blue[500] }} /> : <ExpandMoreIcon sx={{ fill: blue[500] }} />}
            </IconButton>{' '}
            {t('specialInstructions.customerSpecialInstructions')}{' '}
            {!checked && (
              <span style={{ fontSize: '14px', color: red[500] }}>({t('specialInstructions.mustCheckBox')})</span>
            )}
          </h4>
          <FormControlLabel
            label={t('general.complete')}
            control={<Checkbox checked={checked} onChange={onToggle} />}
          />
        </div>
        <Collapse in={open}>
          <div style={{ padding: '8px 4px' }}>
            {instructions.map(instruction => (
              <SpecialInstructionDisplay key={instruction.get('id', 0)} instruction={instruction} />
            ))}
          </div>
        </Collapse>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    fetchSpecialInstructions: (customer, types) =>
      dispatch(fetchCustomerSpecialInstructionsForCustomerWithTypes(customer, types)),
  };
}

const CustomerSpecialInstructionsCollapseContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(CustomerSpecialInstructionsCollapse));

export default CustomerSpecialInstructionsCollapseContainer;
